module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.video && _vm.video.poster && _vm.video.tank) ? _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "640px"
    }
  }, [_c('video', {
    ref: "video",
    staticClass: "video-js vjs-default-skin",
    attrs: {
      "controls": "",
      "preload": "auto",
      "width": "640",
      "height": "480",
      "poster": _vm.video.poster.url,
      "data-setup": "{}"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.video.tank.url,
      "type": _vm.video.tank.type
    }
  }), _vm._v(" "), _vm._m(0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "vjs-no-js"
  }, [_vm._v("\n\t\t\t您的浏览器不支持Html5的视频播放，请使用\n\t\t\t"), _c('a', {
    attrs: {
      "href": "http://sw.bos.baidu.com/sw-search-sp/software/13d93a08a2990/ChromeStandalone_55.0.2883.87_Setup.exe"
    }
  }, [_vm._v("\n\t\t\t\tChrome\n\t\t\t")]), _vm._v("\n\t\t\t浏览器以达到最佳体验。\n\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c7d2eac6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/common/widget/NbVideo.vue
// module id = 1024
// module chunks = 1